import { keyframes } from "@emotion/react";
import styled from "@emotion/styled";
import React from "react";
import { STRINGS } from "../../../strings";
import { translate } from "../../../translate";
import {
  Slide,
  SlideImageContainer,
  SlideInformationText,
  SlideProps,
  SlideSubTitle,
  SlideTitle,
} from "./Slide";
import { default as PhoneSuccessVector } from "/public/assets/phone-success.svg?react";

export const Slide6Congratulations = ({ allCaregiversConfirmed, isBigScreen }: SlideProps) => {
  const sliderMessage = allCaregiversConfirmed
    ? translate(STRINGS.SLIDE_CONGRATULATIONS_VIEW_ASSIGNED_VISITS_SCREEN)
    : translate(STRINGS.SLIDE_CONGRATULATIONS_NEED_TO_GET_MORE_CONFIRMATIONS);

  return (
    <CongratulationsSlide>
      <div>
        <SlideSubTitle>{translate(STRINGS.CONGRATULATIONS).toUpperCase()}</SlideSubTitle>
        <SlideTitle>{translate(STRINGS.YOU_GOT_THE_CASE)}</SlideTitle>
        <SlideInformationText>{sliderMessage}</SlideInformationText>
      </div>
      <AnimatedSlideImageContainer>
        <PhoneSuccessVector height={isBigScreen ? "80%" : "100%"} preserveAspectRatio={"none"} />
      </AnimatedSlideImageContainer>
    </CongratulationsSlide>
  );
};

const bounceUp = keyframes`
  0%   { transform: scale(1,1)    translateY(500px); }
  10%  { transform: scale(1.1,.9) translateY(500px); }
  30%  { transform: scale(.9,1.1) translateY(100px); }
  50%  { transform: scale(1,1)    translateY(0);     }
  57%  { transform: scale(1,1)    translateY(10px);  }
  64%  { transform: scale(1,1)    translateY(0);     }
  100% { transform: scale(1,1)    translateY(0);     }
`;

const flip = keyframes`
  0%   { transform: scale(0.5,0.5) translateY(500px)  rotateY(0);       }
  60%  { transform: scale(1.1,1.1) translateY(-50px) rotateY(720deg);   }
  80%  { transform: scale(.9,.9)   translateY(40px);                    }
  100% { transform: scale(1,1)     translateY(0);                       }
`;

const splash = keyframes`
  0%    { opacity: 0;  scale: 10%;  }
  100%  { opacity: .8; scale: 100%; }
`;

const pulse = keyframes`
  0%    { opacity: .8; scale: 100%; }
  100%  { opacity: 1;  scale: 94%;  }
`;

const AnimatedSlideImageContainer = styled(SlideImageContainer)`
  svg {
    .phone {
      transform-origin: 50% 50%;
      animation: ${bounceUp} 1s ease-in-out forwards;
    }

    .success-ellipse {
      transform: scale(1, 1) translateY(500px);
      transform-origin: 50% 50%;
      animation: ${flip} 0.8s ease-in forwards;
      animation-delay: 0.4s;
    }

    .circle {
      opacity: 0;
      transform-origin: 50% 50%;
      animation: ${splash} 0.4s 0.8s ease-in-out forwards,
        ${pulse} 6s 3s ease-in-out infinite alternate;
    }
  }
`;

const CongratulationsSlide = styled(Slide)`
  justify-content: space-between;

  ${SlideInformationText} {
    font-weight: 800;
  }
`;
